/**
 * The toolbar palette and metrics, from APR's computed styles.
 *
 * Every button: font-size 13px · weight 500 · padding 0 14px · height 34px ·
 * radius 4px · 1.25px border · 8px gap.
 *
 * Each action keeps its own colour — the toolbar is scanned by colour before it is
 * read — and only "Add" is uppercased. That asymmetry is APR's, not an oversight.
 */

const BASE = {
  height: 34,
  minWidth: 0,
  padding: '0 14px',
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.5,
  borderRadius: '4px',
  borderWidth: '1.25px',
  textTransform: 'none',
  '&:hover': { borderWidth: '1.25px' },
} as const;

/** Outlined: the border and the text can differ, and on two buttons they do. */
const outline = (border: string, text: string, hover: string) =>
  ({
    ...BASE,
    color: text,
    borderColor: border,
    backgroundColor: 'transparent',
    '&:hover': { borderWidth: '1.25px', borderColor: border, backgroundColor: hover },
  }) as const;

const filled = (background: string, hover: string) =>
  ({
    ...BASE,
    color: '#ffffff',
    borderColor: background,
    backgroundColor: background,
    '&:hover': { borderWidth: '1.25px', backgroundColor: hover, borderColor: hover },
  }) as const;

export const TOOLBAR = {
  /** The only uppercased label on the screen, with 0.5px tracking. */
  add: {
    ...filled('#1976d2', '#1565c0'),
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  template: outline('#7b1fa2', '#7b1fa2', 'rgba(123, 31, 162, 0.06)'),
  create: outline('#1976d2', '#1565c0', 'rgba(25, 118, 210, 0.06)'),
  update: outline('#e0e0e0', '#424242', 'rgba(0, 0, 0, 0.04)'),
  danger: filled('#c62828', '#b71c1c'),
  // Green border, black label — APR's, and it does look odd next to the others.
  download: outline('#28a745', '#000000', 'rgba(40, 167, 69, 0.06)'),
} as const;
